'use es6';

import { Component } from 'react';
import SlackAPI from '../utils/SlackAPI';
import H2 from 'UIComponents/elements/headings/H2';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import UISection from 'UIComponents/section/UISection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import H5 from 'UIComponents/elements/headings/H5';
import Alerts from '../utils/alerts';
import SlackChannelSelect from '../components/SlackChannelSelect';
import SlackResponseStatusDeterminer from '../utils/SlackResponseStatusDeterminer';
import FailedToLoadChannelsBanner from './FailedToLoadChannelsBanner';
import { UsageTracker } from '../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const I18N_ALERTS = 'slackUiLibrary.shareToSlackSidePanel.alerts';
class ShareToSlackPanel extends Component {
  constructor(props) {
    super(props);
    this.updateSelectedChannel = selectedChannelId => this.setState({
      selectedChannelId
    });
    this.updateMessage = evt => this.setState({
      message: evt.target.value
    });
    this.processSharingResult = response => {
      if (SlackResponseStatusDeterminer.isErrorResponse(response)) {
        this.handleSharingError(response);
        return;
      }
      this.setState({
        isSharing: false,
        sharingFailed: false
      });
      Alerts.displaySuccessSharingAlert(response['@ok']);
      this.props.closePanel();
    };
    this.share = () => {
      this.setState({
        isSharing: true
      });
      SlackAPI.shareToSlack(this.props.recordToShare, this.state.selectedChannelId, this.state.message).then(this.processSharingResult).catch(() => this.handleSharingError());
      UsageTracker.track('record-shared-to-slack', {
        recordId: this.props.recordToShare.id,
        recordType: this.props.recordToShare.type,
        slackChannelId: this.state.selectedChannelId,
        placeIdentifier: this.props.placeIdentifier
      });
    };
    this.setSlackOutageStatus = status => {
      this.setState({
        isSlackOutage: status
      });
    };
    this.state = {
      isSharing: false,
      sharingFailed: false,
      selectedChannelId: undefined,
      message: undefined,
      isSlackOutage: false
    };
  }
  handleSharingError(error) {
    this.setState({
      sharingFailed: true,
      isSharing: false
    });
    let errorId;
    let title;
    let message;
    if (SlackResponseStatusDeterminer.isInvalidAuthError(error)) {
      errorId = `authError`;
      title = `${I18N_ALERTS}.general.invalidAuth.title`;
      message = `${I18N_ALERTS}.general.invalidAuth.message`;
    } else if (SlackResponseStatusDeterminer.isThirdPartyOutageError(error)) {
      errorId = `slackOutageError`;
      title = `${I18N_ALERTS}.messageSharing.error.slackOutage.title`;
      message = `${I18N_ALERTS}.messageSharing.error.slackOutage.message`;
    } else {
      errorId = `defaultSharingError`;
      title = `${I18N_ALERTS}.messageSharing.error.general.title`;
      message = `${I18N_ALERTS}.messageSharing.error.general.message`;
    }
    Alerts.displayErrorAlert(errorId, title, message);
  }
  renderBody() {
    return /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsxs(UISection, {
        children: [/*#__PURE__*/_jsx(H5, {
          children: this.props.description.header
        }), /*#__PURE__*/_jsx(FailedToLoadChannelsBanner, {
          shouldShow: this.state.isSlackOutage
        }), this.props.description.body]
      }), /*#__PURE__*/_jsx(UIFormControl, {
        error: this.state.isSlackOutage,
        validationMessage: this.state.isSlackOutage && /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_ALERTS}.channelsFetching.error.failedToLoadChannels.contextualMessage`
        }),
        children: /*#__PURE__*/_jsx(SlackChannelSelect, {
          disabled: this.state.isSharing,
          onChange: this.updateSelectedChannel,
          setSlackOutageStatus: this.setSlackOutageStatus
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        children: /*#__PURE__*/_jsx(TextArea, {
          padding: "1600",
          paddingInline: "250",
          paddingBlockStart: "250",
          onChange: this.updateMessage,
          disabled: this.state.isSharing,
          placeholder: I18n.text('slackUiLibrary.shareToSlackSidePanel.message.placeholder')
        })
      })]
    });
  }
  renderFooter() {
    return /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_ALERTS}.channelsFetching.error.failedToLoadChannels.buttonTip`
        }),
        disabled: !this.state.isSlackOutage,
        children: /*#__PURE__*/_jsx(UILoadingButton, {
          type: "submit",
          use: "primary",
          loading: this.state.isSharing,
          failed: this.state.sharingFailed,
          onClick: this.share,
          disabled: !this.state.selectedChannelId,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "slackUiLibrary.shareToSlackButton.text"
          })
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: this.props.closePanel,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "slackUiLibrary.shareToSlackSidePanel.cancel"
        })
      })]
    });
  }
  render() {
    return /*#__PURE__*/_jsx(UIModalPanel, {
      width: 500,
      children: /*#__PURE__*/_jsxs(UIForm, {
        children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
          children: [/*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "slackUiLibrary.shareToSlackButton.text"
            })
          }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
            onClick: this.props.closePanel
          })]
        }), this.renderBody(), this.renderFooter()]
      })
    });
  }
}
ShareToSlackPanel.propTypes = {
  closePanel: PropTypes.func,
  recordToShare: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired,
  description: PropTypes.shape({
    header: PropTypes.string.isRequired,
    body: PropTypes.string
  }),
  placeIdentifier: PropTypes.string
};
export default ShareToSlackPanel;